import { IEntityWithSoftDeleteDto } from "@Interfaces/IEntities";
import { z } from "zod";

// Response Dto
export interface GuestHouseResponseDto extends IEntityWithSoftDeleteDto {
    name: string;
    address: string;
    rooms: number;
    beds: number;
    price: number;
    status: string;
    remarks: string;
    entity: {
        id: string;
        name: string;
    };
}

// Form schema
export const guestHouseFormSchema = z.object({
    id: z.string().optional(),
    name: z.string().min(1, { message: "Name is required" }),
    address: z.string().min(1, { message: "Address is required" }),
    rooms: z.number().min(1, { message: "Room count is required" }),
    beds: z.number().min(1, { message: "Bed count is required" }),
    price: z.number().min(1, { message: "Price is required" }),
    remarks: z.string().optional(),
});

export type GuestHouseFormDto = z.infer<typeof guestHouseFormSchema>;
